module.exports = __webpack_public_path__ + "static/media/logo_de_haven.91a1c214.jpg";